const e = {
  getV1ConfigCurrenciesIntent: {
    schema: {
      method: "get",
      url: "/v1/config/currencies/{intent}"
    }
  },
  getV1OwnertypeOwneridCurrenciesIntent: {
    schema: {
      method: "get",
      url: "/v1/{ownerType}/{ownerId}/currencies/{intent}"
    }
  },
  getV1OwnertypeOwneridCurrencies: {
    schema: {
      method: "get",
      url: "/v1/{ownerType}/{ownerId}/currencies"
    }
  },
  getV1OwnertypeOwneridWallets: {
    schema: {
      method: "get",
      url: "/v1/{ownerType}/{ownerId}/wallets"
    }
  },
  postV1OwnertypeOwneridWallets: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/wallets",
      mediaType: "application/json"
    }
  },
  postV1OwnertypeOwneridWalletsIntent: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/wallets/{intent}",
      mediaType: "application/json"
    }
  }
};
export {
  e as v1Service
};
